// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основное меню */
.Menu_menu_div__wRZQA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
  background: linear-gradient(45deg, rgba(187, 22, 22, 1), rgba(187, 22, 22, 1));
  z-index: 1000;
  padding: 0 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 1.2rem;
  position: fixed;
  top: 0;
  left: 0;
}

/* Левый блок с бургером и "Главной" */
.Menu_left_section__MRUOU {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Бургер-кнопка */
.Menu_burger_button__bngKc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  outline: none;
  transition: all 0.3s ease-in-out;
}

.Menu_burger_line__gmZ6K {
  width: 100%;
  height: 3px;
  background-color: white;
  transition: transform 0.3s, opacity 0.3s, background-color 0.3s;
}

.Menu_burger_button__bngKc:hover,
.Menu_burger_button__bngKc:focus {
  background: none;
  box-shadow: none;
  outline: none;
}

.Menu_burger_open__es5o7 .Menu_burger_line__gmZ6K:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.Menu_burger_open__es5o7 .Menu_burger_line__gmZ6K:nth-child(2) {
  opacity: 0;
}

.Menu_burger_open__es5o7 .Menu_burger_line__gmZ6K:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* Кнопка "Главная" */
.Menu_menu_item__YjKfv {
  color: white;
  text-decoration: none;
  font-size: 1.2rem;
  padding: 10px 15px;
  background-color: transparent;
  transition: background-color 0.3s;
}

.Menu_menu_item__YjKfv:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
}

/* Боковая панель */
.Menu_sidebar__GxsMV {
  position: fixed;
  top: 0;
  left: -300px;
  width: 300px;
  height: 100%;
  background-color: rgba(138, 1, 1, 0.9);
  color: white;
  display: flex;
  flex-direction: column;
  padding: 20px;
  transition: left 0.3s ease-in-out;
  z-index: 2000;
}

.Menu_sidebar_open__\\+ehXK {
  left: 0;
}

.Menu_close_sidebar__GOxX6 {
  position: absolute; /* Абсолютное позиционирование */
  top: 10px; /* Расположить кнопку в верхнем правом углу */
  right: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  outline: none;
  transition: color 0.3s ease-in-out;
}

.Menu_close_sidebar__GOxX6:hover,
.Menu_close_sidebar__GOxX6:focus {
  background: none;
  color: rgba(255, 255, 255, 0.8);
}

/* Элементы боковой панели */
.Menu_sidebar_content__ukZds {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Menu_sidebar_item__n8bBx {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  font-size: 1.2rem;
  text-decoration: none;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.Menu_sidebar_item__n8bBx:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Подменю "О нас" */
.Menu_submenu__M6R4a {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 20px;
}

/* Кнопка "Войти/Выйти" */
.Menu_auth_section__\\+FiE\\+ {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.Menu_auth_button__TVxdS {
  color: white;
  text-decoration: none;
  font-size: 1.2rem;
  padding: 10px 15px;
  border: 1px solid white;
  border-radius: 5px;
  background-color: transparent;
  transition: all 0.3s ease-in-out;
}

.Menu_auth_button__TVxdS:hover {
  background-color: white;
  color: rgba(187, 22, 22, 0.8);
}

/* Адаптивность */
@media (max-width: 768px) {
  .Menu_menu_div__wRZQA {
    padding: 0 10px;
  }

  .Menu_menu_item__YjKfv {
    font-size: 1rem;
  }

  .Menu_auth_button__TVxdS {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Menu/Menu.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,8EAA8E;EAC9E,aAAa;EACb,eAAe;EACf,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,OAAO;AACT;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,+DAA+D;AACjE;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB,EAAE,gCAAgC;EACpD,SAAS,EAAE,6CAA6C;EACxD,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Основное меню */\n.menu_div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 60px;\n  background: linear-gradient(45deg, rgba(187, 22, 22, 1), rgba(187, 22, 22, 1));\n  z-index: 1000;\n  padding: 0 20px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  font-size: 1.2rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n\n/* Левый блок с бургером и \"Главной\" */\n.left_section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Бургер-кнопка */\n.burger_button {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 24px;\n  height: 20px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  outline: none;\n  transition: all 0.3s ease-in-out;\n}\n\n.burger_line {\n  width: 100%;\n  height: 3px;\n  background-color: white;\n  transition: transform 0.3s, opacity 0.3s, background-color 0.3s;\n}\n\n.burger_button:hover,\n.burger_button:focus {\n  background: none;\n  box-shadow: none;\n  outline: none;\n}\n\n.burger_open .burger_line:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 5px);\n}\n\n.burger_open .burger_line:nth-child(2) {\n  opacity: 0;\n}\n\n.burger_open .burger_line:nth-child(3) {\n  transform: rotate(-45deg) translate(5px, -5px);\n}\n\n/* Кнопка \"Главная\" */\n.menu_item {\n  color: white;\n  text-decoration: none;\n  font-size: 1.2rem;\n  padding: 10px 15px;\n  background-color: transparent;\n  transition: background-color 0.3s;\n}\n\n.menu_item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n}\n\n/* Боковая панель */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: -300px;\n  width: 300px;\n  height: 100%;\n  background-color: rgba(138, 1, 1, 0.9);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  transition: left 0.3s ease-in-out;\n  z-index: 2000;\n}\n\n.sidebar_open {\n  left: 0;\n}\n\n.close_sidebar {\n  position: absolute; /* Абсолютное позиционирование */\n  top: 10px; /* Расположить кнопку в верхнем правом углу */\n  right: 10px;\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  outline: none;\n  transition: color 0.3s ease-in-out;\n}\n\n.close_sidebar:hover,\n.close_sidebar:focus {\n  background: none;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Элементы боковой панели */\n.sidebar_content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.sidebar_item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: white;\n  font-size: 1.2rem;\n  text-decoration: none;\n  padding: 10px 15px;\n  border-radius: 5px;\n  transition: background-color 0.3s;\n}\n\n.sidebar_item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Подменю \"О нас\" */\n.submenu {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-left: 20px;\n}\n\n/* Кнопка \"Войти/Выйти\" */\n.auth_section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.auth_button {\n  color: white;\n  text-decoration: none;\n  font-size: 1.2rem;\n  padding: 10px 15px;\n  border: 1px solid white;\n  border-radius: 5px;\n  background-color: transparent;\n  transition: all 0.3s ease-in-out;\n}\n\n.auth_button:hover {\n  background-color: white;\n  color: rgba(187, 22, 22, 0.8);\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .menu_div {\n    padding: 0 10px;\n  }\n\n  .menu_item {\n    font-size: 1rem;\n  }\n\n  .auth_button {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu_div": `Menu_menu_div__wRZQA`,
	"left_section": `Menu_left_section__MRUOU`,
	"burger_button": `Menu_burger_button__bngKc`,
	"burger_line": `Menu_burger_line__gmZ6K`,
	"burger_open": `Menu_burger_open__es5o7`,
	"menu_item": `Menu_menu_item__YjKfv`,
	"sidebar": `Menu_sidebar__GxsMV`,
	"sidebar_open": `Menu_sidebar_open__+ehXK`,
	"close_sidebar": `Menu_close_sidebar__GOxX6`,
	"sidebar_content": `Menu_sidebar_content__ukZds`,
	"sidebar_item": `Menu_sidebar_item__n8bBx`,
	"submenu": `Menu_submenu__M6R4a`,
	"auth_section": `Menu_auth_section__+FiE+`,
	"auth_button": `Menu_auth_button__TVxdS`
};
export default ___CSS_LOADER_EXPORT___;
